import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.div`
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 16px;
`;

export { Container, Title };
